const _temp0 = require("./banana.png");
const _temp1 = require("./chicken.png");
const _temp2 = require("./choco.png");
const _temp3 = require("./coffee.png");
const _temp4 = require("./fisch.png");
const _temp5 = require("./kakao.png");
const _temp6 = require("./kokos.png");
const _temp7 = require("./nuss.png");
const _temp8 = require("./phone.png");
const _temp9 = require("./schinken.png");
const _temp10 = require("./sugar.png");
const _temp11 = require("./wolle.png");
module.exports = {
  "banana": _temp0,
  "chicken": _temp1,
  "choco": _temp2,
  "coffee": _temp3,
  "fisch": _temp4,
  "kakao": _temp5,
  "kokos": _temp6,
  "nuss": _temp7,
  "phone": _temp8,
  "schinken": _temp9,
  "sugar": _temp10,
  "wolle": _temp11
}